import type { GenerationJobRow } from "@/types/workspace"

/** Start of a generation job for the elapsed timer: processing start, or enqueue time while still queued. */
export function jobStartedAt(job: GenerationJobRow | null | undefined): string | null {
  if (!job) return null
  return job.started_at ?? job.created_at ?? null
}
